import React, { useCallback } from 'react'
import { FieldProps, getIn } from 'utils-next/forms'

import { AsyncSelect, AsyncSelectProps } from '../../Inputs/Select'

export type AsyncSelectFieldProps = AsyncSelectProps & FieldProps

export function AsyncSelectField({ field, form: { errors, setFieldValue }, ...props }: AsyncSelectFieldProps) {
  const handleChange = useCallback((value: any) => setFieldValue(field.name, value), [field.name, setFieldValue])
  return <AsyncSelect {...field} {...props} onChange={handleChange} error={getIn(errors, field.name)} />
}
